function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "38.616,4.042 34.826,0 114.593,1.514 102.716,21.37 100.565,21.37 99.048,30.213 106.886,43.11  102.716,62.957 104.489,71.559 107.396,74.337 109.287,98.614 107.777,106.195 115.232,117.193 115.232,122.254 117.005,124.403  118.773,122.254 135.585,141.721 137.605,148.673 140.015,151.201 142.414,161.57 145.194,159.677 146.581,166.248 151.137,165.995  154.422,179.521 161.885,182.936 160.746,188.373 165.173,200 117.379,194.949 121.172,189.639 118.268,185.209 122.945,177.37  120.922,169.159 118.268,168.773 111.063,156.26 108.406,157.146 94.624,136.03 73.634,119.095 74.272,111.503 71.868,109.988  71.613,94.821 68.325,89.76 65.929,90.775 66.175,78.126 57.456,66.121 58.089,57.018 45.573,41.597 44.686,33.12 48.227,34.642  48.859,31.231 42.285,23.638 41.399,18.586 43.172,15.17 42.538,11.377 40.141,10.366 "
});

var Svg02 = function Svg02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BC",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/02.37c3aa1e.svg";
export { ForwardRef as ReactComponent };